import script from "./user_image.vue?vue&type=script&setup=true&lang=js"
export * from "./user_image.vue?vue&type=script&setup=true&lang=js"

import "./user_image.vue?vue&type=style&index=0&id=cabd75e2&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cabd75e2"]])

export default __exports__